import { z } from "@/zod";
import { ulid } from "./commonFields";

export const exportJobStatus = z.enum(["pending", "completed", "failed"]);

export const exportJobResponse = z.object({
  job_id: ulid,
  status: exportJobStatus,
});

export const exportStatusResponse = z.object({
  job_id: ulid,
  status: exportJobStatus,
  created_at: z.string().optional(),
  completed_at: z.string().optional(),
  updated_at: z.string().optional(),
  download_url: z.string().url().optional(),
  filename: z.string().min(1).optional(),
  error_message: z.string().min(1).optional(),
});
